<div *ngIf="!isPasswordReset">
  <h1 class="harp-card-title">Reset Password</h1>
  <p>Enter the fields below to reset your password.</p>
  <p>
    All fields marked with an asterisk (<span class="required">*</span>) are
    required.
  </p>

  <form [formGroup]="passwordResetForm" (ngSubmit)="onResetPassword()">
    <harp-input [inputConfig]="passwordInputConfig"></harp-input>
    <harp-input [inputConfig]="confirmPasswordInputConfig"></harp-input>

    <harp-password-strength
      [passwordToCheck]="password"
    ></harp-password-strength>

    <!-- Reset Password Button -->
    <button
      type="submit"
      class="btn btn-primary btn-lg"
      [disabled]="passwordResetForm.invalid"
    >
      Reset Password
    </button>
  </form>
</div>

<!-- Password Reset Successful Message -->
<div *ngIf="isPasswordReset">
  <h1 class="harp-card-title">Success!</h1>
  <p>Your password has been successfully reset.</p>
  <a [routerLink]="['/login']" queryParamsHandling="merge"
    ><strong class="icon ion-md-arrow-round-back"></strong> Back to Login</a
  >
</div>
